// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_4c-2";
export var blackBorderOnHover = "_4c-7";
export var cell = "_4c-6";
export var cellContainer = "_4c-3";
export var checked = "_4c-8";
export var disabled = "_4c-5";
export var featuredIconCellContainer = "_4c-9";
export var featuredIconTextContainer = "_4c-b";
export var featuredIconWrapper = "_4c-a";
export var noBorder = "_4c-c";
export var orangeSelectedRow = "_ch-3";
export var overflowableText = "_4c-0";
export var overflowableTextContainer = "_4c-1";
export var row = "_4e-0";
export var rowCheckboxCell = "_4c-4";
export var selectableTable = "_ch-2";